/* global navigator */

import * as types from '../constants/ActionTypes';

export function changeIsMobile(isMobile) {
  return {
    type: types.CHANGE_IS_MOBILE,
    isMobile,
  };
}

export function changeWidthAndHeight(height, width) {
  return {
    type: types.CHANGE_WIDTH_AND_HEIGHT,
    height,
    width,
  };
}

export function setPopUp(popUp, popUpProps) {
  return {
    type: types.SET_POPUP,
    popUp,
    popUpProps
  };
}

export function initEnvironment() {
  return dispatch => {
    dispatch({ type: 'INIT_APP' });
    const isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i).test(navigator.userAgent);
    // if (isMobile) {
      // document.body.style.overflow = 'hidden';
    // }
    dispatch(changeIsMobile(isMobile));

    const onResize = () => dispatch(changeWidthAndHeight(window.innerHeight, window.innerWidth));
    onResize();
    window.onresize = onResize;
  };
}



// WEBPACK FOOTER //
// ./src/actions/environment.js